'use client';

import { Trophy, X } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { LeaderboardPageContent } from './leaderboard-page-content';

/**
 * In-app leaderboard — same visual language as the profile modal (border, header, close).
 */
export function LeaderboardModal({
  open,
  onOpenChange,
}: {
  open: boolean;
  onOpenChange: (v: boolean) => void;
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        hideClose
        className="max-h-[min(92vh,900px)] w-[min(92vw,32rem)] max-w-lg overflow-hidden border border-amber-500/30 bg-[#0b0a08] p-0 gap-0 text-zinc-100 shadow-[0_30px_120px_-40px_rgba(0,0,0,0.9)]"
      >
        <DialogHeader className="sr-only">
          <DialogTitle>Leaderboard</DialogTitle>
        </DialogHeader>

        <div className="flex max-h-[min(92vh,900px)] min-h-0 flex-col">
          <header className="flex shrink-0 items-start justify-between gap-3 border-b border-amber-500/20 px-4 py-3 sm:px-5">
            <div>
              <div className="flex items-center gap-2 text-sm font-semibold text-amber-100">
                <Trophy className="h-4 w-4" aria-hidden />
                Leaderboard
              </div>
              <p className="mt-1 text-[11px] font-mono uppercase tracking-[0.2em] text-zinc-500">
                Ranked by V2 grid tile value
              </p>
            </div>
            <button
              type="button"
              onClick={() => onOpenChange(false)}
              className="rounded-[4px] border border-amber-500/25 p-1.5 text-zinc-400 transition-colors hover:border-amber-400/50 hover:text-amber-100"
              aria-label="Close leaderboard"
            >
              <X className="h-4 w-4" />
            </button>
          </header>

          <div className="min-h-0 flex-1 overflow-y-auto overflow-x-hidden px-4 py-4 sm:px-5 sm:py-5">
            <LeaderboardPageContent />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
